export const HAS_CLIPBOARD = 'clipboard' in navigator;
export const IS_INSIDE_IFRAME = window.location !== window.top.location;

const checkIsSafari = (): boolean => {
    const userAgent = navigator && navigator.userAgent;
    if (userAgent) {
        return userAgent.includes('Safari') && !userAgent.includes('Chrome');
    }
    return false;
};

export const IS_SAFARI = checkIsSafari();

export const IS_MOBILE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

// iPadOS 13+ defaults to "Request Desktop Website", so the UA reports as
// "Macintosh; Intel Mac OS X" and no longer contains "iPad". The maxTouchPoints
// check distinguishes a real Mac (0 touch points) from an iPad (≥ 2).
export const IS_IOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
